export const galleryImgArray = [
  {
    title: 'фото виробництва',
    imgm: new URL('../../images/gallery/img_5_s@1x.jpg', import.meta.url),
    imgm2: new URL('../../images/gallery/img_5_s@2x.jpg', import.meta.url),
    imgt: new URL('../../images/gallery/img_5_m@1x.jpg', import.meta.url),
    imgt2: new URL('../../images/gallery/img_5_m@2x.jpg', import.meta.url),
    imgd: new URL('../../images/gallery/img_5_l@1x.jpg', import.meta.url),
    imgd2: new URL('../../images/gallery/img_5_l@2x.jpg', import.meta.url),
  },
  {
    title: 'фото цеху',
    imgm: new URL('../../images/gallery/img_4_s@1x.jpg', import.meta.url),
    imgm2: new URL('../../images/gallery/img_4_s@2x.jpg', import.meta.url),
    imgt: new URL('../../images/gallery/img_4_m@1x.jpg', import.meta.url),
    imgt2: new URL('../../images/gallery/img_4_m@2x.jpg', import.meta.url),
    imgd: new URL('../../images/gallery/img_4_l@1x.jpg', import.meta.url),
    imgd2: new URL('../../images/gallery/img_4_l@2x.jpg', import.meta.url),
  },
  {
    title: 'фото складу',
    imgm: new URL('../../images/gallery/img_3_s@1x.jpg', import.meta.url),
    imgm2: new URL('../../images/gallery/img_3_s@2x.jpg', import.meta.url),
    imgt: new URL('../../images/gallery/img_3_m@1x.jpg', import.meta.url),
    imgt2: new URL('../../images/gallery/img_3_m@2x.jpg', import.meta.url),
    imgd: new URL('../../images/gallery/img_3_l@1x.jpg', import.meta.url),
    imgd2: new URL('../../images/gallery/img_3_l@2x.jpg', import.meta.url),
  },
  {
    title: 'фото транспортування',
    imgm: new URL('../../images/gallery/img_2_s@1x.jpg', import.meta.url),
    imgm2: new URL('../../images/gallery/img_2_s@2x.jpg', import.meta.url),
    imgt: new URL('../../images/gallery/img_2_m@1x.jpg', import.meta.url),
    imgt2: new URL('../../images/gallery/img_2_m@2x.jpg', import.meta.url),
    imgd: new URL('../../images/gallery/img_2_l@1x.jpg', import.meta.url),
    imgd2: new URL('../../images/gallery/img_2_l@2x.jpg', import.meta.url),
  },
  {
    title: 'фото родини',
    imgm: new URL('../../images/gallery/img_1_s@1x.jpg', import.meta.url),
    imgm2: new URL('../../images/gallery/img_1_s@2x.jpg', import.meta.url),
    imgt: new URL('../../images/gallery/img_1_m@1x.jpg', import.meta.url),
    imgt2: new URL('../../images/gallery/img_1_m@2x.jpg', import.meta.url),
    imgd: new URL('../../images/gallery/img_1_l@1x.jpg', import.meta.url),
    imgd2: new URL('../../images/gallery/img_1_l@2x.jpg', import.meta.url),
  },
];
